
export default {
  layout: 'login',
};
